module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/196.72b280fb.png";